export default __webpack_public_path__ + "static/media/x.3eacc1e5.svg";